import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./overviewmedium.css";
import { copyToClipboard, innerWidthHandler } from "../../utils/helpers";
import Vimeo from "@u-wave/react-vimeo";
import VideoPopUp from "./videopopup";
import { useDispatch, useSelector } from "react-redux";
import { use } from "react";
import { useTranslation } from "react-i18next";

export default function () {
  const { t } = useTranslation("mediumOverview");
  const width = window.innerWidth;
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const { current_mediumship_level } = useSelector(
    (state) => state.user.user
  );
  const isEligibleMediumLevel =
    current_mediumship_level == 3 ||
    current_mediumship_level == 5 ||
    current_mediumship_level == 6 ||
    current_mediumship_level == 7;
  const canAccessClientOnDemand =
    isEligibleMediumLevel;
  const [toggles, setToggles] = useState({
    toggle1: true,
    toggle2: true,
    toggle3: false,
    toggle4: true,
    toggle5: true,
    toggle6: true,
    toggle7: true,
    toggle8: false,
    toggle9: false,
    toggle10: false,
    toggle11: false,
    toggle12: false,
    toggle13: false,
    toggle14: false,
    toggle15: false,
    toggle16: false,
    toggle17: false,
    toggle18: false,
    toggle19: false,
    toggle20: false,
    toggle21: false,
    toggle22: false,
    toggle23: false,
    toggle24: false,
    toggle25: false,
    toggle26: false,
    toggle27: false,
    toggle28: false,
  });
  const { token_url, test_mode } = useSelector((state) => state.user.user);
  useEffect(() => {
    console.log("Timezone", token_url);
  }, []);
  const [openModal, setOpenModal] = useState(false);
  const [url, setUrl] = useState(1);
  const [yturl, setYtUrl] = useState("");
  const handleToggle = (toggleName) => {
    setToggles((prev) => ({
      ...prev,
      [toggleName]: !prev[toggleName],
    }));
  };

  const openModalHandler = (item, link = "") => {
    setYtUrl(link);
    setUrl(item);
    setOpenModal(!openModal);
  };

  useEffect(() => {
    if (openModal) {
      window.loadModal2("#3-year-video", "show");
    } else {
      window.loadModal2("#3-year-video", "hide");
    }
  }, [openModal]);
  return (
    <>
      <div className="header-saction">
        <div className="container">
          {/* <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <a className="navbar-brand" href="#"><img src="images/Very Soul Logo Black.png" alt="LOGO" /></a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse show" id="navbarSupportedContent">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item active"><a className="nav-link" href="#">How it Works</a></li>
                <li className="nav-item"><a className="nav-link" target='_blank' href="https://verysoul.com/about-us">Our Story</a></li>
                <li className="nav-item"><a className="nav-link" target='_blank' href="https://verysoul.com/members-map">Global Presence</a></li>
                <li className="nav-item"><a className="nav-link" target='_blank' href="https://verysoul.com/reviews">Review</a></li>

                <li className="nav-item">
                  <Link to={""} data-toggle="modal"
                    data-target="#myModal"
                    className="sign-up">Sign Up</Link>


                </li>
                <li className="nav-item">
                  <Link to={"/login"} className='login'>Login</Link>

                </li>
              </ul>
            </div>
          </nav> */}
        </div>
      </div>
      {/* <div className="banner-saction1">

          <img className='w-100' src="images/Mask-Group-20-1.jpg" alt='banner' />

      </div> */}
      <div className="py-5 offerings-container">
        {/* VerySoul Gift — mediums can give a session with another medium too. */}
        <div className="gift-shortcut-banner">
          <div>
            <strong>{t("giftBanner.title")}</strong>
            <p className="mb-0">
              {t("giftBanner.text")}
            </p>
          </div>
          <button type="button" className="main-btn" onClick={() => navigate("/give-a-gift", { state: { from: "/shortcuts" } })}>
            {t("giftBanner.button")}
          </button>
        </div>
        <h2 className="section-title">{t("title")}</h2>
        <div className="row ">
          {/* Practice with Mediums */}
          <div className="col-md-6 col-sm-12  col-lg-4 mainCard">
            <div
              className={`card offerings-card border-0 p-3 h-100 ${
                toggles.toggle3 ? "height-80-px overflow-hidden" : ""
              }`}
            >
              <div
                className={`card-header offerings-header ${
                  toggles.toggle3
                    ? "offerings-header-up"
                    : "offerings-header-up "
                }`}
                onClick={() => handleToggle("toggle3")}
              >
                {t("manageDay.title")}
              </div>
              <div className="card-body">
                <ul className="list-unstyled mt-3">
                  <ul className={`offerings-list`}>
                    <li className="sub-list-item-last uppercase">
                      <span className="list-icon"></span>
                      <Link to={"/appointments"} className="anchore-tags">
                        {" "}
                        {t("manageDay.upcoming")}{" "}
                      </Link>
                    </li>
                    <li className="sub-list-item-last uppercase">
                      <span className="list-icon"></span>
                      <Link
                        to={"/go-on-demand-practice?to=ondemand"}
                        className="anchore-tags"
                      >
                        {" "}
                        {t("manageDay.lastMinute")}
                      </Link>
                    </li>
                    {canAccessClientOnDemand ? (
                      <li className="sub-list-item-last uppercase">
                        <span className="list-icon"></span>
                        <Link
                          to={"/go-on-demand-client"}
                          className="anchore-tags"
                        >
                          {t("manageDay.onDemandClients")}
                        </Link>{" "}
                      </li>
                    ) : (
                      ""
                    )}
                    <li className="sub-list-item-last uppercase">
                      <span className="list-icon"></span>
                      <Link
                        to={"/go-on-demand-practice"}
                        className="anchore-tags"
                      >
                        {" "}
                        {t("manageDay.specialEvent")}
                      </Link>
                    </li>
                    <li className="sub-list-item-last uppercase disabled-date gray">
                      <span className="list-icon "></span>
                      <a href={"#"} className="anchore-tags ">
                        {" "}
                        {t("manageDay.goOffline")}
                      </a>
                    </li>
                  </ul>
                </ul>
              </div>
              <div className="corner-fold"></div>
            </div>
            <div
              className={`card offerings-card border-0 p-3 h-100 ${
                toggles.toggle1 ? "height-80-px overflow-hidden" : ""
              }`}
            >
              <div
                className={`card-header offerings-header ${
                  toggles.toggle1
                    ? "offerings-header-up"
                    : "offerings-header-up "
                }`}
                onClick={() => handleToggle("toggle1")}
              >
                {t("practice.title")}{" "}
              </div>
              <div className="card-body">
                <ul className="list-unstyled mt-3">
                  <li
                    onClick={() => handleToggle("toggle8")}
                    className={`mb-2 d-flex align-items-center justify-content-between ${
                      toggles.toggle8
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("practice.oneOnOne")}
                    </strong>{" "}
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle8 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li>
                      <span className="list-icon"></span>{" "}
                      <Link to={"/go-on-demand-practice?to=ondemand"}>
                        {t("practice.lastMinuteMatch")}
                      </Link>
                    </li>
                    <ul className="sub-list">
                      <li className="sub-list-item sub-list-item-last disabled-date gray">
                        {t("practice.extraSitter")}
                      </li>
                    </ul>
                    <li>
                      <span className="list-icon"></span> {t("practice.scheduledAdvance")}
                    </li>
                    <ul className="sub-list">
                      <li className="sub-list-item">
                        <Link to={"/booking?to=bookwithother"}>
                          {t("practice.bookAnother")}
                        </Link>
                      </li>
                      <li className="sub-list-item  sub-list-item-last">
                        <Link to={"/availability"}>
                          {t("practice.takeBookings")}
                        </Link>{" "}
                      </li>
                    </ul>
                    <li>
                      <span className="list-icon"></span> {t("practice.relatedSkills")}
                    </li>
                    <ul className="sub-list">
                      <li className="sub-list-item  sub-list-item-last disabled-date gray">
                        {t("practice.psychic")}
                      </li>
                    </ul>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle9")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle9
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("practice.group")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle9 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item">
                      {/* /go-on-demand-practice?to=practicecircles */}
                      <Link to={"/go-on-demand-practice?to=allpracticecircles"}>
                        {" "}
                        {t("practice.circles")}
                      </Link>
                    </li>
                    <li className="sub-list-item-last">
                      {" "}
                      {/* go-on-demand-practice?to=coachedgroupcoaching */}
                      <Link to={"/go-on-demand-practice?to=allpracticecircles"}>
                        {" "}
                        {t("practice.coachedCircles")}
                      </Link>
                    </li>

                    <li className="sub-list-item-last">
                      <span className="list-icon "></span>{" "}
                      <Link
                        to={"/go-on-demand-practice?to=platformDemonstration"}
                      >
                        {t("practice.demonstrations")}
                      </Link>
                    </li>
                  </ul>
                </ul>
              </div>
              <div className="corner-fold"></div>
            </div>
            <div
              className={`card offerings-card border-0 p-3 h-100 ${
                toggles.toggle6 ? "height-80-px overflow-hidden" : ""
              }`}
            >
              <div
                className={`card-header offerings-header ${
                  toggles.toggle6
                    ? "offerings-header-up"
                    : "offerings-header-up "
                }`}
                onClick={() => handleToggle("toggle6")}
              >
                {t("clients.title")}
              </div>
              <div className="card-body">
                <ul className="list-unstyled mt-3">
                  <li
                    onClick={() => handleToggle("toggle10")}
                    className={`mb-2 d-flex align-items-center justify-content-between ${
                      toggles.toggle10
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("clients.conduct")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle10 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link to={"/appointments"}>{t("clients.scheduled")}</Link>{" "}
                    </li>
                    {canAccessClientOnDemand ? (
                      <li className="sub-list-item-last">
                        <span className="list-icon"></span>
                        <Link to={"/go-on-demand-client"}>
                          {t("clients.onDemand")}
                        </Link>{" "}
                      </li>
                    ) : (
                      ""
                    )}
                    {/* <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> On Demand Sessions
                      (TBD)
                    </li> */}
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link
                        to={
                          "/go-on-demand-practice?to=professionalDemonstrations"
                        }
                      >
                        {t("clients.proDemo")}
                      </Link>{" "}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span>
                      <Link to={"/backfill"}>
                        {t("clients.backfill")}
                      </Link>{" "}
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle11")}
                    className={`mb-2 d-flex align-items-center justify-content-between ${
                      toggles.toggle11
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("clients.guidance")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle11 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("clients.practiceProgram")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("clients.starterProgram")}
                    </li>
                    {canAccessClientOnDemand &&
                     <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link
                        to={
                          "/go-on-demand-client"
                        }
                      >
                        {t("clients.outreachProgram")}
                      </Link>{" "}
                    </li>
                      }
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("clients.professionalProgram")}
                    </li>
                  </ul>
                </ul>
              </div>
              <div className="corner-fold"></div>
            </div>
          </div>

          {/* Learn About VerySoul */}

          <div className="col-md-6 col-sm-12 col-lg-4 mainCard">
            <div
              className={`card offerings-card border-0 p-3 h-100 ${
                toggles.toggle5 ? "height-80-px overflow-hidden" : ""
              }`}
            >
              <div
                className={`card-header offerings-header ${
                  toggles.toggle5
                    ? "offerings-header-up"
                    : "offerings-header-up "
                }`}
                onClick={() => handleToggle("toggle5")}
              >
                {t("support.title")}
              </div>
              <div className="card-body">
                <ul className="list-unstyled mt-3">
                  <li
                    onClick={() => handleToggle("toggle12")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle12
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("support.coached")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle12 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link to={"/booking?to=coaching1on1"}>
                        {t("support.oneOnOne")}
                      </Link>{" "}
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link to={"/go-on-demand-practice?to=groupcoaching"}>
                        {" "}
                        {t("support.smallGroups")}
                      </Link>
                    </li>

                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link to={"/go-on-demand-practice?to=allpracticecircles"}>
                        {" "}
                        {t("support.circlesCoaching")}
                      </Link>
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle13")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle13
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("support.events")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle13 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("support.qa")}
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon "></span>
                      <Link to={"/go-on-demand-practice?to=speakerEvents"}>
                        {" "}
                        {t("support.speakerEvents")}
                      </Link>{" "}
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon "></span>
                      <Link
                        to={"/go-on-demand-practice?to=platformDemonstration"}
                      >
                        {t("practice.demonstrations")}
                      </Link>
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon "></span>
                      <Link to={"/go-on-demand-practice?to=speakerEventsPast"}>
                        {" "}
                        {t("support.recorded")}
                      </Link>{" "}
                    </li>
                    {/* <ul>
                      <li
                        className="sub-list-item-last text-underline pointer"
                        onClick={() => openModalHandler(2,'https://player.vimeo.com/video/1102200623?h=8a9e5382e2&badge=0&autopause=0&player_id=0&app_id=58479')}
                      >
                      Confidence in Mediumship (with Q&As) - Hosted by Stacey Decea
                      </li>
                      <li
                        className="sub-list-item-last text-underline pointer"
                        onClick={() => openModalHandler(1)}
                      >
                        3 year Celebration video
                      </li>
                       <li
                        className="sub-list-item-last text-underline pointer"
                        onClick={() => openModalHandler(2,'https://player.vimeo.com/video/1086182187?h=fcbbba54aa&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479')}
                      >
                      The Critical Voice of the Medium
                      </li>
                    </ul> */}
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle14")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle14
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("support.talk")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle14 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    {/* <li className='sub-list-item-last disabled-date gray'><span className="list-icon "></span> Affinity Groups (TBD)</li> */}
                    {/* <li className='sub-list-item-last disabled-date gray'><span className="list-icon "></span> Support Groups (TBD)</li> */}
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link
                        to={"/go-on-demand-practice?to=communitysupportgroups"}
                      >
                        {t("support.communityGroups")}
                      </Link>{" "}
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle15")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle15
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("support.systemHelp")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle15 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("support.infoSession")}
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <a
                        href={process.env.REACT_APP_SUPPORT_URL}
                        target="_blank"
                      >
                        {" "}
                        {t("common:common.submitTicket")}
                      </a>
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link to={"/booking?to=supportteam"}>
                        {t("support.helpAppointment")}
                      </Link>{" "}
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle16")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle16
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("support.outsideTeachers")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle16 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("support.shareFavorites")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("support.insights")}
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle17")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle17
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {" "}
                      {t("support.bookPro")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle17 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span>
                      <Link to={"/booking?to=professionalsessions"}>
                        {" "}
                        {t("support.bookHere")}
                      </Link>
                    </li>
                  </ul>
                </ul>
              </div>
              <div className="corner-fold"></div>
            </div>
            <div
              className={`card offerings-card border-0 p-3 h-100 ${
                toggles.toggle2 ? "height-80-px overflow-hidden" : ""
              }`}
            >
              <div
                className={`card-header offerings-header ${
                  toggles.toggle2
                    ? "offerings-header-up"
                    : "offerings-header-up "
                }`}
                onClick={() => handleToggle("toggle2")}
              >
                {t("career.title")}
              </div>
              <div className="card-body">
                <ul className="list-unstyled mt-3">
                  <li
                    onClick={() => handleToggle("toggle18")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle18
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("career.feedback")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle18 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>{" "}
                      <Link to={"/feedbacks"}>{t("career.reviewFeedback")}</Link>
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span>
                      <a
                        target="_blank"
                        href={"https://verysoul.com/medium-faqs/#survey_levels"}
                      >
                        {t("career.howFeedback")}
                      </a>
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle19")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle19
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("career.progress")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle19 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span>
                      <a
                        target="_blank"
                        href={
                          "https://verysoul.com/medium-faqs/#mediumship_levels"
                        }
                      >
                        {t("career.levels")}
                      </a>
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("career.dashboard")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span>
                      <a
                        target="_blank"
                        href="https://formfacade.com/public/107057487601614273004/all/form/1FAIpQLSfTwin7OfGF3KfX3KRFn5vM2i_he6147o3lodTzPB4FyhFMng"
                      >
                        {t("career.competency")}
                      </a>{" "}
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle20")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle20
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("career.setback")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle20 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link to={"/booking?to=findacoach"}>
                        {t("career.findCoach")}
                      </Link>{" "}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("career.steppingBack")}
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle21")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle21
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle disabled-date gray">
                      {t("career.readiness")}
                    </strong>
                  </li>
                </ul>
              </div>
              <div className="corner-fold"></div>
            </div>
          </div>

          {/* Work With Clients */}
          <div className="col-md-6 col-sm-12 col-lg-4  mainCard">
            <div
              className={`card offerings-card border-0 p-3 h-100 ${
                toggles.toggle7 ? "height-80-px overflow-hidden" : ""
              }`}
            >
              <div
                className={`card-header offerings-header ${
                  toggles.toggle7
                    ? "offerings-header-up"
                    : "offerings-header-up "
                }`}
                onClick={() => handleToggle("toggle7")}
              >
                {t("supportVerySoul.title")}
              </div>
              <div className="card-body">
                <ul className="list-unstyled mt-3">
                  <li
                    onClick={() => handleToggle("toggle22")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle22
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("supportVerySoul.social")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle22 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <a
                        href="https://www.facebook.com/VerySoulApp1"
                        target="_blank"
                      >
                        {" "}
                        Facebook
                      </a>
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>{" "}
                      <a
                        href="https://www.instagram.com/verysoulapp/"
                        target="_blank"
                      >
                        Instagram
                      </a>
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle23")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle23
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">{t("supportVerySoul.refer")}</strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle23 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <Link to={"/refer-others"}>
                        {" "}
                        {t("supportVerySoul.starterVolunteers")}
                      </Link>
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.mediums")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.translators")}
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle24")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle24
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("supportVerySoul.volunteer")}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle24 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.asExtra")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.asFacilitator")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.asBuddy")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.asCoach")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.asTranslator")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.asSpeaker")}
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle25")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle25
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">
                      {t("supportVerySoul.connections")}{" "}
                    </strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle25 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.podcasters")}
                    </li>
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("supportVerySoul.sponsors")}
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle26")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle26
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">{t("supportVerySoul.fund")}</strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle26 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>{" "}
                      <a
                        target="_blank"
                        href={
                          "https://buy.stripe.com/bIY2884XR4oDck86oo?locale=en&__embed_source=buy_btn_1RNv5VHzWXOgYzHHpJUIIiKN"
                        }
                      >
                        {t("supportVerySoul.contribute")}
                      </a>
                    </li>
                  </ul>
                </ul>
              </div>
              <div className="corner-fold"></div>
            </div>
            <div
              className={`card offerings-card border-0 p-3 h-100 ${
                toggles.toggle4 ? "height-80-px overflow-hidden" : ""
              }`}
            >
              <div
                className={`card-header offerings-header ${
                  toggles.toggle4
                    ? "offerings-header-up"
                    : "offerings-header-up "
                }`}
                onClick={() => handleToggle("toggle4")}
              >
                {t("learn.title")}
              </div>
              <div className="card-body">
                <ul className="list-unstyled mt-3">
                  <li
                    onClick={() => handleToggle("toggle27")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle27
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">{t("learn.background")}</strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle27 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last disabled-date gray">
                      <span className="list-icon "></span> {t("learn.programsOverview")}
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <a
                        target="_blank"
                        href={"https://verysoul.com/operating-principle/"}
                      >
                        {" "}
                        {t("learn.principles")}
                      </a>
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <a
                        target="_blank"
                        href={"https://verysoul.com/code-of-ethics/"}
                      >
                        {" "}
                        {t("learn.ethics")}
                      </a>
                    </li>
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>
                      <a
                        target="_blank"
                        href={"https://verysoul.com/medium-faqs/"}
                      >
                        {t("learn.faq")}
                      </a>
                    </li>
                  </ul>
                  <li
                    onClick={() => handleToggle("toggle28")}
                    className={`mb-2 d-flex align-items-center justify-content-between
                    ${
                      toggles.toggle28
                        ? "offerings-header-inner"
                        : "offerings-header-up-inner "
                    }`}
                  >
                    <strong className="offerings-subtitle">{t("learn.media")}</strong>
                  </li>
                  <ul
                    className={`offerings-list ${
                      toggles.toggle28 ? "height-0-px overflow-hidden" : ""
                    }`}
                  >
                    <li className="sub-list-item-last">
                      <span className="list-icon"></span>{" "}
                      <a target="_blank" href="/mediums">
                        {" "}
                        {t("learn.viewMedia")}
                      </a>
                    </li>
                    <ul className="sub-list">
                      <li className="sub-list-item">{t("learn.allAbout")}</li>
                      <ul>
                        <li
                          className="sub-list-item-last text-underline pointer"
                          onClick={() =>
                            openModalHandler(
                              2,
                              "https://www.youtube.com/embed/61CHrJlmsKA"
                            )
                          }
                        >
                          {t("learn.videos.mediumshipWorld")}
                        </li>
                        <li
                          className="sub-list-item-last text-underline pointer"
                          onClick={() =>
                            openModalHandler(
                              2,
                              "https://www.youtube.com/embed/e5CdsdbqXBo?si=EBFLQu34xRUoGQrh"
                            )
                          }
                        >
                          {t("learn.videos.spiritGuided")}
                        </li>
                        <li
                          className="sub-list-item-last text-underline pointer"
                          onClick={() =>
                            openModalHandler(
                              2,
                              "https://www.youtube.com/embed/Dy5XLUNro9Y?si=sHBb3Tqlll6MYToI"
                            )
                          }
                        >
                          {t("learn.videos.mediumCurious")}
                        </li>
                        <li
                          className="sub-list-item-last text-underline pointer"
                          onClick={() =>
                            openModalHandler(
                              2,
                              "https://www.youtube.com/embed/s7b54xpE17o?si=mZ4ixnZ4Ff_HH_Me"
                            )
                          }
                        >
                          {t("learn.videos.reliableMedium")}
                        </li>
                      </ul>
                      <li className="sub-list-item-last">
                        <span className="list-icon"></span>{t("learn.honorable")}
                      </li>
                      <ul>
                        <li
                          className="sub-list-item-last text-underline pointer"
                          onClick={() =>
                            openModalHandler(
                              2,
                              "https://www.youtube.com/embed/fRtg42ecyZ0?si=kik0rT1aXlBAXChG"
                            )
                          }
                        >
                          {t("learn.videos.elizabethFried")}
                        </li>
                      </ul>
                    </ul>

                    <li className="sub-list-item-last">
                      <span className="list-icon"></span> {t("learn.recommend")}
                    </li>
                    <ul className="sub-list">
                      <li className="sub-list-item sub-list-item-last disabled-date gray">
                        <Link to={"/url-submission-profile"}>
                          {t("learn.submitUrl")}
                        </Link>{" "}
                      </li>
                    </ul>
                  </ul>
                </ul>
              </div>
              <div className="corner-fold"></div>
            </div>

            {/* come here new */}
          </div>
        </div>
        <div className="footer-saction-home">
          <div className="container">
            <div className="footer-logo-home">
              <img src="images/Union-icon.png" />{" "}
            </div>
            <p>{t("footer.tagline")}</p>
            <ul>
              <li>
                <Link target="_blank" to={"/terms-conditions"}>
                  {t("common:common.termsConditions")}
                </Link>
                {/* <a href='#'>Terms& Conditions</a> */}
              </li>
              <li>|</li>
              <li>
                <Link target="_blank" to={"/privacy-policy"}>
                  {t("common:common.privacyPolicy")}
                </Link>
                {/* <a href='#'>Privacy Policy</a> */}
              </li>
            </ul>
            {/* <span><b>Note: For optimum performance: use Chrome, Safari, or Edge</b></span> */}
            <span>{t("footer.copyright")}</span>
          </div>
        </div>
      </div>
      {openModal && (
        <VideoPopUp setOpenModal={setOpenModal} url={url} yturl={yturl} />
      )}
    </>
  );
}
